import z from "zod/v4";
import { AccuracySchema } from "./accuracy-model";

export const PerformanceModelSchema = z.object({
    wins: z.number(),
    losses: z.number(),
    draws: z.number(),
    winPercentage: z.number(),
    accuracy: AccuracySchema,
});

export type PerformanceModel = z.infer<typeof PerformanceModelSchema>;
